module.exports = __webpack_public_path__ + "static/media/14UNEP24.9cbf8dd2.jpg";